import { TextSeparator } from '@/components/custom';
import { useUrlParams } from '../hooks';
import { useScreenSize } from '@/hooks';

const ViewDataTitle = () => {

  const { status } = useScreenSize();
  const { tab, source } = useUrlParams();

  const title = (
    tab === 'users'
      ? (source === 'refund' ? 'Achats remboursés par Apple ou Google' : 'Signalements émis par nos utilisateurs')
      : 'Signalements émis par les vérificateurs'
  );

  const align = (
    status === 'mobile'
      ? 'center'
      : 'left'
  );

  if (status === 'isLoading') {
    return <></>;
  }

  return (
    <TextSeparator
      title={title}
      className='text-xs'
      align={align} />
  );

};

export default ViewDataTitle;
